import { formatAmount, THINSP } from './formatAmount';

const amountFormatter = (value, showCurrency = false, currency = { code: 'RUR', minority: 0 }) => {
  const amount = { value, currency };
  const { value: amountValue, currencySymbol } = formatAmount(amount);

  return showCurrency ? `${amountValue}${THINSP}${currencySymbol}` : amountValue;
};

export default amountFormatter;
